// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instrument-form {
    list-style: none;
    margin: 0 auto;
    padding: 1rem;
    width: 90%;
    max-width: 40rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    border-radius: 6px;
    background: white
}

.instrument-form .button-group {
    display: flex;
    justify-content: center; /* Center aligns the buttons horizontally */
    padding: 10px; /* Adds padding around the buttons */
    gap: 10px; /* Space between the two buttons */
    margin-top: 20px; /* Adds margin on top of the button group */
}

.trade-list {
    width: 100%;
    max-width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    box-sizing: border-box;
}

.horizontal-slider {
    width: 100%;
    max-width: 90%;
    margin: 30px auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.button-group {
    width: 100%;
    max-width: 90%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    margin: 10px auto;
}
  
.button-group .button {
    width: 100%;
    max-width: 90%;
    text-align: center;
    margin: 10px auto;
}

/* The slider and the range buttons stay at the bottom of the window while
   the page scrolls (sticky within <main>, under the header's z-index 5);
   compact, so they cover little of the charts */
.chart-controls {
    position: sticky;
    bottom: 0;
    z-index: 4;
    padding: 6px 5% 8px;
    background: #ffffff;
    border-top: 1px solid #e6e6e6;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
}

.chart-controls .horizontal-slider {
    max-width: 100%;
    margin: 4px 0 10px;
}

.chart-controls .button-group {
    max-width: 100%;
    margin: 0;
    gap: 8px;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
}

.chart-controls .button-group .button {
    max-width: 100%;
    margin: 0;
    padding: 6px 10px;
}

.instrument-actions {
    margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/pages/InstrumentDetails.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,2CAA2C;IACpE,aAAa,EAAE,oCAAoC;IACnD,SAAS,EAAE,kCAAkC;IAC7C,gBAAgB,EAAE,2CAA2C;AACjE;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;gDAEgD;AAChD;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,2DAA2D;AAC/D;;AAEA;IACI,eAAe;IACf,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".instrument-form {\n    list-style: none;\n    margin: 0 auto;\n    padding: 1rem;\n    width: 90%;\n    max-width: 40rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n    border-radius: 6px;\n    background: white\n}\n\n.instrument-form .button-group {\n    display: flex;\n    justify-content: center; /* Center aligns the buttons horizontally */\n    padding: 10px; /* Adds padding around the buttons */\n    gap: 10px; /* Space between the two buttons */\n    margin-top: 20px; /* Adds margin on top of the button group */\n}\n\n.trade-list {\n    width: 100%;\n    max-width: 90%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.horizontal-slider {\n    width: 100%;\n    max-width: 90%;\n    margin: 30px auto;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n}\n\n.button-group {\n    width: 100%;\n    max-width: 90%;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 10px;\n    margin: 10px auto;\n}\n  \n.button-group .button {\n    width: 100%;\n    max-width: 90%;\n    text-align: center;\n    margin: 10px auto;\n}\n\n/* The slider and the range buttons stay at the bottom of the window while\n   the page scrolls (sticky within <main>, under the header's z-index 5);\n   compact, so they cover little of the charts */\n.chart-controls {\n    position: sticky;\n    bottom: 0;\n    z-index: 4;\n    padding: 6px 5% 8px;\n    background: #ffffff;\n    border-top: 1px solid #e6e6e6;\n    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.chart-controls .horizontal-slider {\n    max-width: 100%;\n    margin: 4px 0 10px;\n}\n\n.chart-controls .button-group {\n    max-width: 100%;\n    margin: 0;\n    gap: 8px;\n    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n}\n\n.chart-controls .button-group .button {\n    max-width: 100%;\n    margin: 0;\n    padding: 6px 10px;\n}\n\n.instrument-actions {\n    margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
